import { NavLink, useLocation } from 'react-router-dom';
// mantine
import { Avatar } from '@mantine/core';
// components
import { base64ToImageSource } from '@newo/toolkit/image';
import Logo from '@/components/Logo';
import NavigationItem from '@/components/Layout/components/Navigation/components/NavigationItem';
// utils
import { cn } from '@/utils';
import navItems from '@/constants/navigation.tsx';
import { useProfileQuery } from '@/services/customer/profile/profile.queries.ts';
// assets
import styles from '@/components/Layout/components/Navigation/Navigation.module.css';
import { PATHS } from '@/constants';

const FIRST_LETTER_INDEX = 0;

const Navigation = () => {
    const location = useLocation();
    const isCreatePartnerPage = location.pathname.includes(PATHS.createPartner);

    const { data: profile } = useProfileQuery(!isCreatePartnerPage);

    if (isCreatePartnerPage) {
        return;
    }

    return (
        <nav className={styles.nav}>
            <Logo className="hidden md:block" variant="icon" />
            {navItems.map(({ icon, idn, label, path, isPrimary }) => {
                const supIcon =
                    idn === 'billing' && profile?.status === 'temporal'
                        ? '⚠️'
                        : undefined;
                return (
                    <NavigationItem
                        className={cn({
                            'hidden md:block': !isPrimary
                        })}
                        icon={icon}
                        key={path}
                        label={label}
                        path={path}
                        supIcon={supIcon}
                    />
                );
            })}

            <NavLink
                className="mt-auto no-underline text-[10px] text-gray-6 hover:text-gray-7 text-center md:hidden"
                to="/profile"
            >
                <Avatar
                    className="w-10 h-10 md:w-9 md:h-9 mb-0.5 shrink-0"
                    color="blue"
                    radius="xl"
                    size="2rem"
                    src={
                        profile?.logo
                            ? base64ToImageSource(profile.logo)
                            : undefined
                    }
                >
                    {(profile?.last_name ?? '')
                        .at(FIRST_LETTER_INDEX)
                        ?.toUpperCase()}
                </Avatar>
                <span className="hidden md:block">Profile</span>
            </NavLink>
        </nav>
    );
};

export default Navigation;
